<template>
  <transition name="fade"
    @before-enter="beforeEnter" @enter="enter"
    @before-leave="beforeLeave" @leave="leave"
  >
    <slot />
  </transition>
</template>

<script>
  export default {
    methods: {
      beforeEnter: function() {
        this.$emit('nested-beforeEnter');
      },
      enter: function() {
        this.$emit('nested-enter');
      },
      beforeLeave: function() {
        this.$emit('nested-beforeLeave');
      },
      leave: function() {
        this.$emit('nested-leave');
      },
    },
  }
</script>

<style>
/*
---IMPORTANT---
if you want objects to fade into another, make sure that:
  1. parent has position: relative
  2. at least one child has position: absolute
  3. child appearance is cared for with position: absolute
*/

  .fade-enter-active, .fade-leave-active {
    transition: all .25s ease-out;
    overflow: hidden;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
    transform-origin: top center;
    overflow: hidden;
  }
</style>
